module.exports = __webpack_public_path__ + "img/h-warning.57b22e88.svg";